import { httpInstance } from "../http/http";

export class AppleId {
    async appleSignIn(callback: Function) {
        try {
            const data = await this.signIn(),
                email = await this.getEmailFromAppleId(data);

            if (email) {
                callback(email);
            } else {
                console.error("AppleId: brak emaila");
            }

        } catch (errorObj) {
            console.error("AppleID:", errorObj);
        }
    }

    async signIn(): Promise<AppleSignInAPI.SignInResponseI> {
        return await AppleID.auth.signIn();
    }

    async getEmailFromAppleId(data: AppleSignInAPI.SignInResponseI): Promise<string | null> {
        return data.user && data.user.email ?
            data.user.email :
            await this.getUserEmailFromAWS(data.authorization);
    }

    async getUserEmailFromAWS(authorization: AppleSignInAPI.AuthorizationI): Promise<string | null> {
        try {
            const userFromAWS = await httpInstance
                .get({
                    url: `https://aws.squid.wyborcza.pl/services/pub/rest/appleId/getEmailByIdentityToken?identityToken=${authorization.id_token}`
                });

            return userFromAWS && userFromAWS.data && userFromAWS.data.email ? userFromAWS.data.email : null;
        } catch (error) {
            return null;
        }
    }

    initAuth() {
        try {
            AppleID.auth.init({
                clientId: "pl.wyborcza",
                scope: "email",
                redirectURI: window.location.origin,
                state: window.location.href,
                nonce: "[NONCE]",
                usePopup: true
            });
        } catch (error) {
            console.error("AppleID.auth.init", error);
        }
    }

    bindFunctionToWindow() {
        window["social-media-apple"] = {
            login: (callback: Function) => {
                this.appleSignIn(callback);
            },
            logout: () => { return undefined }
        }
    }

    init() {
        this.initAuth();
        this.bindFunctionToWindow();
    }
}